import { UserRound } from 'lucide-react'
import './Avatar.css'

const GLYPH_SIZE = { sm: 15, md: 19, lg: 24 }
const TINTS = 6

/**
 * Stable small hash, so a person keeps the same tint across every screen they
 * appear on — the list, the drawer head and the details page all agree.
 */
function tintOf(name) {
  let hash = 0
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) | 0
  return Math.abs(hash) % TINTS
}

/**
 * A person mark.
 *
 * The legacy panel renders Metronic's `blank.png` for every user, so there is no
 * photo to show. This used to fall back to initials, which read as data the row
 * did not have — two letters of a name already printed beside them. A glyph says
 * "person" and lets the name do the identifying; the disc's tint (hashed off the
 * name) keeps a long list scannable.
 *
 * @param {string} name
 * @param {'sm'|'md'|'lg'} [size]
 * @param {boolean} [solid]  the signed-in user — accent fill rather than tint
 */
export default function Avatar({ name = '', size = 'md', solid = false, className = '' }) {
  const classes = [
    'avatar',
    `avatar--${size}`,
    solid ? 'avatar--solid' : `avatar--t${tintOf(name)}`,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={classes} aria-hidden="true">
      <UserRound size={GLYPH_SIZE[size]} strokeWidth={1.75} />
    </span>
  )
}
